import {Component, inject, input, OnInit} from '@angular/core'
import {KycService} from '../../services/kyc.service'
import {BorgoKycComponent} from '../borgo-kyc/borgo-kyc.component'

@Component({
  selector: 'spb-home',
  templateUrl: './home.component.html',
  imports: [
    BorgoKycComponent
  ],
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  public step = input<string>('1')

  private readonly kycService = inject(KycService)

  public ngOnInit(): void {
    this.kycService.getKyc().subscribe()
  }
}
